define.alias("ember-power-select/components/power-select/trigger", "media/components/power-select/trigger");